import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TrendModel } from '../../../shared/data/models/trend.model';
import { Store } from '@ngrx/store';
import * as fromHome from '../../state';
import {
  getHashTrends,
  getHashTrendsError,
  getHashTrendsLoading
} from '../../state/selectors/trending-hash.selector';
import { loadHashTag } from '../../state/actions/trending-hashtag.actions';

@Component({
  selector: 'anms-full-trends',
  templateUrl: './full-trends.component.html',
  styleUrls: ['./full-trends.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullTrendsComponent implements OnInit {
  hashTrends$: Observable<TrendModel[]>;
  hashTrendError$: Observable<string>;
  hashTrendLoading$: Observable<boolean>;

  constructor(private store$: Store<fromHome.State>) {}

  ngOnInit(): void {
    this.hashTrends$ = this.store$.select(getHashTrends);
    this.hashTrendError$ = this.store$.select(getHashTrendsError);
    this.hashTrendLoading$ = this.store$.select(getHashTrendsLoading);

    // pull trends - 15
    this.store$.dispatch(loadHashTag({ count: 15 }));
  }

  generateRandomColors(): string {
    return '#' + Math.floor(Math.random() * 16777215).toString(16);
  }
}
